<template>
  <g @mousedown="mousedown">
    <circle :cx = "cx" :cy = "cy" r = "17" fill = 'var(--inlet)' />
    <circle :cx = "cx" :cy = "cy" r = "12" fill = 'white' />
    <circle :cx = "cx" :cy = "cy" r = "9" fill = 'var(--inlet)' />
    <text :x="cx - 5" :y="cy + 3.5" class="inlet-text">
      IN
    </text>
  </g>
</template>

<script>
export default {
  name: 'InletHandle',
  props: [
    'cx',
    'cy',
    'mousedown'
  ]
};
</script>

<style scoped>
.inlet-text {
  fill: white;
  font-weight: 900;
  font-size: 65%;
}
</style>